let code = 'potencialsolar';
let codeAPI = 'potencialsolar';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};